import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type IDeviceState = {
  isIOS: boolean;
  isStandalone: boolean;
  pwaIOS: {
    isShow: boolean;
    closed_at: string | null;
  };
};

const initialState: IDeviceState = {
  isIOS: false,
  isStandalone: false,
  pwaIOS: {
    isShow: true,
    closed_at: null,
  },
};

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setIsIOS: (state, action: PayloadAction<boolean>) => {
      state.isIOS = action.payload;
    },

    setIsStandalone: (state, action: PayloadAction<boolean>) => {
      state.isStandalone = action.payload;
    },

    closePwaPopUp: (state) => {
      state.pwaIOS = {
        isShow: false,
        closed_at: new Date().toUTCString(),
      };
    },

    showPwaPopUp: (state) => {
      state.pwaIOS = {
        isShow: true,
        closed_at: null,
      };
    },
  },
});

export default deviceSlice.reducer;

export const { setIsIOS, closePwaPopUp, showPwaPopUp, setIsStandalone } =
  deviceSlice.actions;
